var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveStrom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118.186,
    height: 234.691,
    viewBox: "0 0 118.186 234.691",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c,.e{fill:#fff;}.b{fill:currentColor;}.c{font-size:23px;font-family:Roboto-Bold, Roboto;}.c,.e{font-weight:700;}.d,.e{font-family:Oswald-Bold, Oswald;}.e{font-size:28px;}.f,.i{fill:none;}.f{stroke:#fff;stroke-width:3px;}.g{fill:#40424c;}.h{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -290.174)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.08 356)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1050.687,1574.783a2.42,2.42,0,0,0-2.419,2.419,7.23,7.23,0,0,1-5.007,6.86c-1.974-24.672-29.491-42.993-58.934-37.246a19.313,19.313,0,0,0-25.558-5.709,2.422,2.422,0,0,0,0,4.19,14.629,14.629,0,0,1,6.816,9.012c-9.545,6.245-16.037,15.316-18.151,25.311h-8.011a2.42,2.42,0,0,0-2.419,2.418v19.352a2.42,2.42,0,0,0,2.419,2.419h11.562a44.182,44.182,0,0,0,19.883,18.6v15.263a2.419,2.419,0,1,0,4.838,0v-13.14a55.785,55.785,0,0,0,38.7,0v13.135a2.419,2.419,0,1,0,4.838,0v-15.239c13.734-6.778,23.168-19.114,24.058-33.371a12.1,12.1,0,0,0,9.806-11.862A2.42,2.42,0,0,0,1050.687,1574.783Zm-84.661,9.676a4.838,4.838,0,1,1,4.838-4.838A4.842,4.842,0,0,1,966.026,1584.458Z",
    transform: "translate(-937 -1538.499)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M174.486,2977h15.551l-12.76,20.556h15.976l-33.514,38.375,10.76-26.384H157.734Z",
    transform: "translate(-113.94 -2957.607)"
  })), /*#__PURE__*/React.createElement("text", {
    className: "c",
    transform: "translate(22.08 491.865)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xD8"), /*#__PURE__*/React.createElement("tspan", {
    className: "d",
    y: 0,
    xmlSpace: "preserve"
  }, " 334 \u20AC"), /*#__PURE__*/React.createElement("tspan", {
    className: "d"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26
  }, "Ersparnis"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-801 -4310)"
  }, /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(864.187 4637.363)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Strom")), /*#__PURE__*/React.createElement("g", {
    className: "f",
    transform: "translate(821 4609)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 33,
    height: 33,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 1.5,
    y: 1.5,
    width: 30,
    height: 30,
    rx: 6.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M12.071,41.015q-.865-1.9-1.057-2.379L9.548,35.248Q8.875,33.686,8.395,32.7l-.889-1.8a16.882,16.882,0,0,0-6.08-7.185q4.109-3.46,7.329-3.46A3.965,3.965,0,0,1,12.119,21.9a15.463,15.463,0,0,1,2.091,5.707q6.248-11.847,9.732-16.365a21.817,21.817,0,0,1,5.347-5.383,11.474,11.474,0,0,1,5.9-1.322,16.006,16.006,0,0,1,5,.889Q33.915,9.535,26.5,18.931A163.045,163.045,0,0,0,12.071,41.015Z",
    transform: "translate(824 4595.637)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveStrom);
export default __webpack_public_path__ + "static/media/SaveStrom.369249e5.svg";
export { ForwardRef as ReactComponent };